import { CustomerList } from '@malesia/react-components/dist/src/components/Customer/List';
import { SortingDataType } from '@malesia/react-components/dist/src/components/Table';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    selectList,
    selectFilterData,
    selectIsLoading,
    selectIsDirty,
} from '../selectors';
import { actions } from '../slice';
import { useTableColumns } from '../tableColumns';

export const CustomerListWithStore: SFC = () => {
    const list = useSelector(selectList);
    const filterData = useSelector(selectFilterData);
    const isLoading = useSelector(selectIsLoading);
    const isDirty = useSelector(selectIsDirty);

    const dispatch = useDispatch();

    const handleSetSort = (data: SortingDataType) => {
        dispatch(actions.setSorting(data));
    };

    const customerListColumns = useTableColumns();

    return (
        <CustomerList
            isLoading={isLoading}
            isDirty={isDirty}
            onSubmit={(data) => {
                dispatch(actions.setFilterData(data));
            }}
            searchText={filterData.searchText}
            isActiveOnly={filterData.isActiveOnly}
            tableColumns={customerListColumns}
            tableData={list.items}
            sortBy={filterData.sortBy}
            sortOrder={filterData.sortOrder}
            setSort={handleSetSort}
        />
    );
};
